import { createChildListModalComponent } from 'factories/ChildListModal'
import { tableCellComponents } from 'helpers/listItems'

export default createChildListModalComponent({
  getStorageKey: (self) => 'lists.addFromFile',
  tableCellComponents,
})()
